import React from 'react';
import { useHistory } from 'react-router-dom';
import Notice from 'Shared/components/notice';
import { useTranslation } from 'Shared/util/custom-hooks';


const InvoiceManualNotice = () => {
  const history = useHistory();
  const t = useTranslation(x => x.notices);

  return (
    <Notice
      svgPath="/invoice-and-magnifier.svg"
      content={t.submitAndSellYourInvoice}
      button={{
        text: t.sellInvoices,
        onClick: () => history.push('/sales-methods/manual-setup'),
      }}
    />
  );
};

export default InvoiceManualNotice;
